import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const STAGES = ["Submitted", "PMO Gate", "SCG Gate", "Active"];

// Maps each stage index to the approvalStages key
const STAGE_KEYS = ["submitted", "pmoGate", "scgGate", "active"];

const ApprovalPipeline = ({ approvalStages }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "0", mt: "10px", mb: "6px" }}>
      {STAGES.map((label, i) => {
        const done = approvalStages?.[STAGE_KEYS[i]] === true;
        const isLast = i === STAGES.length - 1;

        return (
          <Box key={label} sx={{ display: "flex", alignItems: "center" }}>

            {/* Dot */}
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
              <Box sx={{
                width: "10px", height: "10px", borderRadius: "50%",
                background: done ? t.accent : "transparent",
                border: `2px solid ${done ? t.accent : t.border3}`,
                transition: "all 0.2s",
              }} />
              <Typography sx={{
                fontFamily: "'DM Mono', monospace",
                fontSize: "8px", letterSpacing: "0.1em",
                textTransform: "uppercase",
                color: done ? t.accent : t.text3,
                whiteSpace: "nowrap",
              }}>
                {label}
              </Typography>
            </Box>

            {/* Connector line — not after last dot */}
            {!isLast && (
              <Box sx={{
                width: "60px", height: "2px",
                background: done ? t.accent : t.border2,
                mb: "16px",
                transition: "background 0.2s",
              }} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default ApprovalPipeline;